// @flow

import {useEffect} from 'react';
import {debounce} from 'docs/util';

export const useWindowResizeEffect = (
  func: () => any,
  debounceInterval?: number | null = null,
) => {
  useEffect(() => {
    const debouncedFunc = debounceInterval
      ? debounce(func, debounceInterval)
      : func;
    window.addEventListener('resize', debouncedFunc);
    return () => window.removeEventListener('resize', debouncedFunc);
  }, [debounceInterval, func]);
};
